import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import ArrowButton from '../common/button-arrow';
import ToastMessage from '../common/toast-message';
import irelandApi from '../../irelandApi';

class RedeemModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redeemValue: null,
      redeemValueError: null,
      redeemTerms: false,
      redeemTermsError: null,
      isSubmitted: false
    }
  }

  handleInputUpdate = e => {
    this.setState({
      [e.target.name]: e.target.value
    }, () => {
      this.validate();
    });
  }

  validate = () => {
    const { maxMonetaryValue } = this.props;
    const { redeemValue } = this.state;

    if (redeemValue == null) {
      this.setState({ redeemValueError: 'value must be filled' });
    } else if (redeemValue < 0) {
      this.setState({ redeemValueError: 'value must be positive' });
    } else if (Number.isInteger(redeemValue)) {
      this.setState({ redeemValueError: 'value must be a whole number' });
    } else if (redeemValue < 25) {
      this.setState({ redeemValueError: 'value must be greater than €25' });
    } else if (redeemValue > maxMonetaryValue) {
      this.setState({
        redeemValueError: `Unfortunately you are unable to redeem this amount as you will exceed your redemption threshold for this redemption period. The maximum you can redeem is ${maxMonetaryValue}`
      });
    } else {
      this.setState({ redeemValueError: null });
    }
  }

  handleCheckTerms = () => {
    const { redeemTerms } = this.state;

    this.setState({
      redeemTerms: !redeemTerms
    }, () => {
      if (redeemTerms == true) {
        this.setState({ redeemTermsError: null });
      }
    });
  }

  handleCompleteOrder = () => {
    const { outlet, setRewardDataAfterRedeem } = this.props;
    const { redeemValueError, redeemTerms, redeemValue } = this.state;

    if (redeemValueError === null && redeemTerms) {
      irelandApi.post(`api/rewards`, {
        order: {
          amount_requested: redeemValue,
          outlet_id: outlet
        }
      })
      .then((response) => {
        const responseOrder = response.data.data.attributes['order'];
        const order = {
          nextOrderAmount: responseOrder['next_order_amount'],
          totalVouchersAvailable: responseOrder['total_vouchers_available'],
          vouchersRedeemed: responseOrder['vouchers_redeemed'],
          individualBalance: responseOrder['individual_balance'],
          transferAmount: responseOrder['transfer_amount']
        };

        setRewardDataAfterRedeem(order);
        this.handleResetModalBeforeClose();
        toast.success(<ToastMessage iconStyle="success" message="Funds successfully redeemed"/>);
      })
      .catch(error => {
        this.setState({ isSubmitted: false, redeemTermsError: error.response.data.errors });
      })
  } else {
      this.validate();

      if (!redeemTerms) {
        this.setState({ isSubmitted: false, redeemTermsError: 'terms must be accepted' });
      }
    }
  }

  handleSubmit = () => {
    this.setState({ isSubmitted: true }, () => {
      this.handleCompleteOrder();
    });
  }

  handleResetModalBeforeClose = () => {
    const { handleRedeemFundsModal } = this.props;

    this.setState({
      redeemValue: null,
      redeemValueError: null,
      redeemTerms: false,
      redeemTermsError: null,
      isSubmitted: false
    }, () => {
      handleRedeemFundsModal();
    });
  }

  render() {
    const { redeemModalActive, maxVoucherValue, maxVouchersForDuration } = this.props;
    const { redeemValueError, redeemTermsError, redeemValue, redeemTerms, isSubmitted } = this.state;

    return (
      <Modal show={redeemModalActive} backdrop='static' keyboard={false} onHide={() => this.handleResetModalBeforeClose()} dialogClassName="my-rewards-redeem-modal">
        <Modal.Header>
          <h2>Redeem my rewards now</h2>
        </Modal.Header>
        <Modal.Body>
          <div className="important-container">
            <h4>Important! you may be missing out!</h4>
          </div>
          <div className="info-container">
            <p>By manually redeeming your funds now you could be missing out on maximising your earnings.</p>
            <p>Your yearly redemption threshold allows you to make no more than <span style={{ fontWeight: 700 }}>{maxVouchersForDuration}</span> redemptions per year with each of those redemptions having a maximum value of up to <span style={{ fontWeight: 700 }}>€{maxVoucherValue}</span> worth of points</p>
          </div>
          <div className="form-container">
            <p>I would like to redeem €<input className="redeem-input" name="redeemValue" type="number" min="1" step="1" value={redeemValue} onChange={(e) => this.handleInputUpdate(e)} /> worth of vouchers immediately</p>
            <p className="redeem-value-error">{redeemValueError}</p>
            <p className="terms" onClick={() => this.handleCheckTerms()}><input className="redeem-check" type="checkbox" name="redeemTerms" checked={redeemTerms} /><span className="checkmark"></span>I confirm that this is my decision and I understand that by redeeming my points now, I may not be able to redeem the maximum number of points available to me this redemption period.</p>
            <p className="redeem-value-error">{redeemTermsError}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <ArrowButton arrow={false} color='red' submit={false} onClick={() => this.handleResetModalBeforeClose()}>Cancel</ArrowButton>
          <ArrowButton arrow={false} color='green' submit={false} disabled={isSubmitted} onClick={() => this.handleSubmit()}>Confirm and redeem</ArrowButton>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RedeemModal;



// WEBPACK FOOTER //
// ./src/components/my-rewards/redeem-modal.jsx